import { inject } from 'mobx-react';
import * as React from 'react';

import { AnalyticsStore, QueryRoute, RouteStore } from 'bernie-core';
import { Layer } from 'bernie-view';
import { LocalizedComponentProps, withLocalization } from 'bernie-l10n';

import { CurrentHotelStore } from 'stores/current-hotel-store';

import { GalleryViewModel } from 'src/common/models';

import { UitkCard, UitkCardContent, UitkCardMedia, UitkCardTextSegment } from 'uitk-react-cards';
import { UitkMediaGalleryThumbnailView } from 'uitk-react-media-gallery';
import { UitkPill } from 'uitk-react-pill';

import { GalleryDialog } from 'components/infosite/property-details/gallery-dialog';

interface GalleryByCategoriesProps extends LocalizedComponentProps {
  analytics: AnalyticsStore;
  routeStore?: RouteStore;
  currentHotel: CurrentHotelStore;
  gallery: GalleryViewModel;
  trackingRfrr: string;
  id: number;
}

interface GalleryByCategoriesState {
  selectedPill: string;
}

@withLocalization
@inject('routeStore', 'analytics')
export class GalleryByCategories extends React.Component<GalleryByCategoriesProps, GalleryByCategoriesState> {
  constructor(props) {
    super(props);

    this.state = {
      selectedPill: props.gallery.categories && props.gallery.categories.length > 0 ? props.gallery.categories[0].id : undefined
    };
    this.onImageSelected = this.onImageSelected.bind(this);
    this.openPhotoGalleryDialog = this.openPhotoGalleryDialog.bind(this);
    this.onPillSelect = this.onPillSelect.bind(this);
    this.updateIndex = this.updateIndex.bind(this);
    this.galleryDialogCloseCallback = this.galleryDialogCloseCallback.bind(this);
  }

  public render(): JSX.Element {
    const { gallery, currentHotel, trackingRfrr, id } = this.props;
    const { selectedPill } = this.state;

    const isCategoriesShowable = gallery && gallery.categories && gallery.categories.length > 0 && selectedPill;
    const selectedCategory = isCategoriesShowable ? gallery.categories.filter(x => x.id === selectedPill)[0] : null;
    const selectedImages = selectedCategory ? selectedCategory.images : gallery.images;

    const currentGalleryIndex = (currentHotel && currentHotel.photoGalleryIndex) || 0;
    const param = { pwaDialog: `photoGalleryCategory-${id}` };

    return (
      <div>
        <QueryRoute query={param}>
          <Layer id="photoGalleryCategory-trigger" onDismiss={this.galleryDialogCloseCallback}>
            <GalleryDialog
              currentIndex={currentGalleryIndex}
              galleryDialogCloseCallback={this.galleryDialogCloseCallback}
              galleryName={trackingRfrr}
              images={selectedImages}
              onIndexChange={this.updateIndex}
              trackingRfrr={trackingRfrr}
            />
          </Layer>
        </QueryRoute>
        {isCategoriesShowable && (
          <UitkCard>
            <UitkCardContent>
              <UitkCardTextSegment className="uitk-grid all-grid-nowrap uitk-scroll-horizontal">
                {gallery.categories.map(category => (
                  <UitkPill id={category.id} key={category.id} onChange={this.onPillSelect} checked={selectedPill === category.id}>
                    {category.name} ({category.images.length})
                  </UitkPill>
                ))}
              </UitkCardTextSegment>
              <UitkCardMedia className="media-gallery-mosaic">
                <UitkMediaGalleryThumbnailView images={selectedImages} onImageSelected={this.onImageSelected} />
              </UitkCardMedia>
            </UitkCardContent>
          </UitkCard>
        )}
      </div>
    );
  }

  public onPillSelect(evt): void {
    const selectedPill = evt.target.id;
    const { analytics, gallery } = this.props;
    const { categories } = gallery;
    const selectedCategory = categories.find(x => x.id === selectedPill);
    const pillOrder = categories.findIndex(x => x.id === selectedPill);
    analytics.clickTracker(`.PhotoGalleryTrigger.[${selectedCategory.id}][${pillOrder}]`, 'Photo tab pill', null, null)();
    this.setState({ selectedPill });
  }

  private onImageSelected(index: number) {
    const { gallery, analytics, trackingRfrr } = this.props;
    const { selectedPill } = this.state;
    const { categories } = gallery;
    if (categories && categories.length > 0) {
      analytics.clickTracker(`.${trackingRfrr}.[${selectedPill}][${index}]`, 'Display Photo tab carousel', null, null)();
    } else {
      analytics.clickTracker(`.${trackingRfrr}.[NoCategories][${index}]`, 'Display Photo tab carousel', null, null)();
    }
    this.updateIndex(index);
    this.openPhotoGalleryDialog();
  }

  private updateIndex(index: number): void {
    const { currentHotel } = this.props;

    if (currentHotel && typeof currentHotel.setCurrentGalleryIndex === 'function') {
      currentHotel.setCurrentGalleryIndex(index);
    }
  }

  private openPhotoGalleryDialog(): void {
    this.props.routeStore.updateSearch({ pwaDialog: `photoGalleryCategory-${this.props.id}` });
  }

  private galleryDialogCloseCallback() {
    const { routeStore } = this.props;
    if (routeStore && typeof routeStore.goBack === 'function') {
      routeStore.goBack();
    }
  }
}
